import axiosClient from "api/axios_client.js";

const apiCompany = {
  create: (payload) => axiosClient.post(`/companies/company-configuration/create`, payload),
  update: (id, payload) => axiosClient.put(`/companies/company-configuration/update/${id}`, payload),
  getById: (id) => axiosClient.get(`/companies/company-configuration/get-by-id/${id}`),
  delete: (ids) => axiosClient.delete(`/companies/company-configuration/delete`, { data: { ids } }),

  getCountries: () => axiosClient.get(`/directories/business-master/country-directory/get-all`),
  toggleStatus: (id) => axiosClient.put(`/companies/company-configuration/toggle-status/${id}`),
  getAllClients: (payload) => axiosClient.post(`/user/get-all`, payload),

};

export default apiCompany;

